"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});var r=(e=>(e.PREV="Prev",e.NEXT="Next",e))(r||{});exports.PaginationButtonType=r;
